var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _circle, _circle2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 150,
    viewBox: "0 0 300 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 150,
    fill: "#E2E5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 22,
    width: 177,
    height: 111,
    fill: "#9CA5A9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 19,
    width: 177,
    height: 111,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 44,
    width: 14,
    height: 6,
    fill: "#424E54"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 44,
    width: 23,
    height: 6,
    fill: "#424E54"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 44,
    width: 10,
    height: 6,
    fill: "#424E54"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 44,
    width: 21,
    height: 6,
    fill: "#424E54"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 52,
    width: 21,
    height: 6,
    fill: "#424E54"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 52,
    width: 13,
    height: 6,
    fill: "#424E54"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 52,
    width: 19,
    height: 6,
    fill: "#424E54"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 64,
    width: 62,
    height: 6,
    fill: "#727E84"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 43,
    width: 46,
    height: 43,
    fill: "#B9BFC2"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 70,
    width: 46,
    height: 43,
    fill: "#D5D8DA"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 214.5,
    y: 19.5,
    width: 56,
    height: 32,
    fill: "#E0EEF8",
    stroke: "#ADADAD"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 214.5,
    y: 56.5,
    width: 56,
    height: 32,
    fill: "#F9E8E8",
    stroke: "#ADADAD"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 72,
    width: 62,
    height: 6,
    fill: "#727E84"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 80,
    width: 62,
    height: 6,
    fill: "#727E84"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 88,
    width: 41,
    height: 6,
    fill: "#727E84"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 32,
    width: 20,
    height: 8,
    fill: "#CA3C3D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 242.5,
    cy: 33.5,
    r: 7.5,
    fill: "#4DA3D4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 242.5,
    cy: 70.5,
    r: 7.5,
    fill: "#DA7777"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M259 51C247.577 51 238.269 51 226 51C226 46.5817 233.387 43 242.5 43C251.613 43 259 46.5817 259 51Z",
    fill: "#4DA3D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M259 88C247.577 88 238.269 88 226 88C226 83.5817 233.387 80 242.5 80C251.613 80 259 83.5817 259 88Z",
    fill: "#DA7777"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.2375752e4d7ea3fd6f8ed18140b23149.svg";
export { ForwardRef as ReactComponent };